import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import APIs from '../commons/consts/API'
import { environment } from '../environments/environment'
import { RequestUpgradePackage } from '../interfaces/subscription'

const SERVER_URL = environment.API_WS_SERVER_URL
@Injectable({
  providedIn: 'root'
})
export class SubScriptionService {
  constructor(private http: HttpClient) {}

  upgradePackage(body: RequestUpgradePackage): Observable<any> {
    let url = SERVER_URL + APIs.UPGRADE_PACKAGE
    return this.http.post(url, body)
  }

  getCurrentAndNextPackage() {
    let url = SERVER_URL + APIs.CURRENT_AND_NEXT_PACKAGE
    return this.http.get<any>(url)
  }
}
